import {Box, Theme, Typography, useMediaQuery} from "@material-ui/core";
import GradientSwitch from "./GradientSwitch";
import React, {FC, useEffect, useState} from "react";
import {partialUpdateProperty} from "../../../../redux/actions/propertyActions";
import {useSelector} from "../../../../redux/store";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

type PropsType = {
  propertyId: string
  published: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const PublishedWidget: FC<PropsType> = ({propertyId, published, onChange}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [state, setState] = useState(false)
  const user = useSelector((state) => state.authReducer.user);
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  useEffect(() => {
    setState(published)
  }, [published])

  const handlePublishedWidget = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event)
    const { checked } = event.target
    setState(checked)
    const data = {published: checked}
    await dispatch(partialUpdateProperty(data, user!.token, propertyId))
  }

  return (
    <Box display='flex' alignItems='center'>
      <Box mr={2}>
        <Typography noWrap={xs} style={{fontWeight: 500}}>{t('widget')} {state ? t('published') : t('unpublished')}</Typography>
      </Box>
      <GradientSwitch
        checked={state}
        onChange={handlePublishedWidget}
      />
    </Box>
  )
}
export default PublishedWidget